export default __webpack_public_path__ + "static/media/bookathon.3b7ee082.png";